import { render, staticRenderFns } from "./TaskbarActivitySection.vue?vue&type=template&id=59590fac&scoped=true&"
import script from "./TaskbarActivitySection.vue?vue&type=script&lang=js&"
export * from "./TaskbarActivitySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59590fac",
  null
  
)

export default component.exports